// extracted by mini-css-extract-plugin
export var gif = "_ki-0";